module.exports = __webpack_public_path__ + "static/media/kredytomat-banner-small.5fac14d7.jpg";